import type { Endpoint } from '../lib/endpoint';

/**
 * Reactive origin/dest holder — endpoint plus its display label. Keeping the
 * label alongside the endpoint means URL restore hydrates the visible input
 * text from one place instead of two out-of-sync signals.
 */
export class EndpointsStore {
  origin = $state<Endpoint | undefined>(undefined);
  dest = $state<Endpoint | undefined>(undefined);
  originLabel = $state('');
  destLabel = $state('');

  /**
   * Replaces origin (pass undefined to clear). `label` overwrites the input
   * mirror; omitting it (default `''`) blanks the text — always pass a label
   * to preserve typed input.
   */
  setOrigin(endpoint: Endpoint | undefined, label = ''): void {
    this.origin = endpoint;
    this.originLabel = label;
  }

  /**
   * Replaces dest (pass undefined to clear). `label` overwrites the input
   * mirror; omitting it (default `''`) blanks the text — always pass a label
   * to preserve typed input.
   */
  setDest(endpoint: Endpoint | undefined, label = ''): void {
    this.dest = endpoint;
    this.destLabel = label;
  }

  /** Exchanges origin and dest — endpoints and labels — in place. */
  swap(): void {
    const temporaryEndpoint = this.origin;
    const temporaryLabel = this.originLabel;
    this.origin = this.dest;
    this.originLabel = this.destLabel;
    this.dest = temporaryEndpoint;
    this.destLabel = temporaryLabel;
  }

  /** True when both `origin` and `dest` are set. */
  get isReady(): boolean {
    return this.origin !== undefined && this.dest !== undefined;
  }
}
